import { API_ENDPOINTS } from "../utils/apiEndpoints";
import { apiClient, WHOLE_USE_MOCK } from "./api";
import { mockDataUtil } from "./mockDataUtil";
import axios from "axios";
import sha256 from "crypto-js/sha256";

class AuthService {
  /**
   * 用户登录
   */
  async login(credentials) {
    // return apiClient.post('/auth/login', credentials);
    //
    if ((await apiClient.getMock()) && WHOLE_USE_MOCK) {
      if (
        credentials.username === "admin" &&
        credentials.password === "admin123"
      ) {
        return mockDataUtil.mockRes({
          loginId: "admin",
          name: "管理员",
          token: "mock-token-12345",
        });
      }
      return mockDataUtil.mockCreateErrorRes("用户名或密码错误", 401);
    } else {
      let req = {
        deviceType: "PC",
        deviceId: "",
        loginId: credentials.username,
        password: sha256(credentials.password).toString(),
        // validCode,
        // redirectURL,
      };
      return apiClient.post(API_ENDPOINTS.AUTH.LOGIN, req);
    }
  }

  async resetPassword(loginId, pwd, pwd2, validCode) {
    let req = {
      loginId,
      oldPassword: sha256(pwd).toString(),
      newPassword: sha256(pwd2).toString(),
      validCode,
    };
    return apiClient.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, req);
  }

  /**
   * 获取用户信息
   */
  async getUserProfile() {
    if ((await apiClient.getMock()) && WHOLE_USE_MOCK) {
      return mockDataUtil.mockRes({
        loginId: "admin",
        name: "管理员",
        email: "admin@example.com",
        mobile: "13800138000",
        orgName: "系统管理部",
      });
    } else {
      return apiClient.get(API_ENDPOINTS.AUTH.ACCOUNT_INFO);
    }
  }

  /**
   * 用户登出
   */
  async logout() {
    // 实际项目中可能需要调用登出接口
    return Promise.resolve({
      success: true,
      code: 200,
      message: "登出成功",
      data: null,
    });
  }

  // 菜单接口
  async getMenu() {
    const res = await axios.get("/auth/api/v1/account/menu/tree", {});
    return res;
  }

  async listAccount(nameLike) {
    if ((await apiClient.getMock()) && WHOLE_USE_MOCK) {
      // 从mockAccountData.js导入用户数据
      const { accounts } = await import("../mock/mockAccountData.js");

      // 过滤用户数据（如果提供了搜索关键词）
      let filteredAccounts = accounts;
      if (nameLike) {
        filteredAccounts = accounts.filter(
          (account) =>
            account.name.toLowerCase().includes(nameLike.toLowerCase()) ||
            account.loginId.toLowerCase().includes(nameLike.toLowerCase())
        );
      }

      // 将用户数据转换为操作组管理需要的格式
      const accountOptions = filteredAccounts.map((account) => ({
        label: account.name,
        value: account.loginId, // 使用loginId作为唯一标识
      }));

      return mockDataUtil.mockRes(accountOptions);
    } else {
      const res = await apiClient.post(API_ENDPOINTS.AUTH.LIST_ACCOUNT, {
        nameLike: nameLike,
        pageSize: 100,
      });
      return res;
    }
  }

  async userInfo() {
    if ((await apiClient.getMock()) && WHOLE_USE_MOCK) {
      return mockDataUtil.mockRes({
        loginId: "admin",
        name: "管理员",
        email: "admin@example.com",
        mobile: "13800138000",
        orgName: "系统管理部",
      });
    } else {
      return apiClient.post(API_ENDPOINTS.AUTH.USER_INFO);
    }
  }

  async updateCurrentWarehouse(param) {
    const res = await apiClient.post(
      API_ENDPOINTS.AUTH.UPDATE_WAREHOUSE,
      param
    );
    return res;
  }
}

export const authService = new AuthService();
